<div class="untapped-card">
    <!-- Gradient header -->
    <div class="poster-row">
        <div class="promo-left">
            <div class="eyebrow-pill">
                <app-icon type="sparkle" class="eyebrow-icon" />
                <span class="eyebrow-text">Untapped Potential</span>
            </div>
            <div class="heading-block">
                <div class="headline">
                    <p>Get more out of</p>
                    <p>Bob Construction AI</p>
                </div>
                <p class="subtitle">Unlock advanced features and boost your team productivity by 10x.</p>
            </div>
        </div>
        <div class="mascot-image">
            <img src="images/untapped-potential-mascot.png" alt="" class="mascot-img" />
        </div>
    </div>

    <!-- Feature chips -->
    <ng-container *ngIf="data() as d">
        <div *ngIf="d.features.length > 0; else allExplored" class="features-section">
            <div class="features-row">
                <button
                    *ngFor="let feature of d.features.slice(0, 10)"
                    type="button"
                    class="feature-chip"
                    (click)="onFeatureClick(feature)">
                    <div class="chip-icon-container" [style.background]="getFeatureVisual(feature.id).iconBg">
                        <app-icon [type]="getFeatureVisual(feature.id).iconName" [style.color]="getFeatureVisual(feature.id).iconColor" [strokeWidth]="2" class="chip-icon" />
                    </div>
                    <span class="chip-label">{{ feature.label }}</span>
                </button>
            </div>
        </div>

        <ng-template #allExplored>
            <div class="all-explored-state">
                <i class="pi pi-check-circle"></i>
                <div class="all-explored-heading">You have explored all features</div>
                <div class="all-explored-sub">Great job — there is nothing untapped to discover.</div>
            </div>
        </ng-template>
    </ng-container>
</div>
